import { render, staticRenderFns } from "./CreateExercisePage.vue?vue&type=template&id=5208d810&"
import script from "./CreateExercisePage.vue?vue&type=script&lang=js&"
export * from "./CreateExercisePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports